import React from "react";

export default function JS_Encapsulation() {
  return (
    <div className="tutorial-container">
      <h1>JS Encapsulation</h1>
      <p>
        This tutorial explains the concept of JS Encapsulation in JavaScript
        OOPs.
      </p>
    </div>
  );
}
